<template>
  <div class="alarm-Page">
    <childNav
      :routerName="$t('breadcrumbItem.alarm')"
      :backFlag="true"
    ></childNav>
    <div class="page-body">
      <div class="page-box">
        <!-- 头部配置 -->
        <Row class="row-margin">
          <i-col :span="20" class="text-left">
            <!-- 防区类型 -->
            <RadioGroup
              v-model="addForm.zoneMode"
              type="button"
              button-style="solid"
              size="large"
            >
              <Radio
                v-for="(item, index) in alarmList"
                :key="index"
                :label="item.value"
                border
              >
                <span>{{ item.label }}</span>
              </Radio>
            </RadioGroup>
            <!-- 在家离家状态 -->
            <RadioGroup
              v-model="addForm.name"
              type="button"
              button-style="solid"
              size="large"
              class="radio-item"
            >
              <Radio
                v-for="(item, index) in nameList"
                :key="index"
                :label="item.value"
                border
              >
                <span>{{ item.label }}</span>
              </Radio>
            </RadioGroup>
            <!-- 防区扩展 -->
            <Checkbox
              v-model="addForm.exZone"
              class="radio-item"
              size="large"
              border
              >{{ $t("alarm.alarmPlus") }}</Checkbox
            >
          </i-col>
          <i-col :span="4" class="text-right">
            <Poptip v-model="visible" placement="bottom">
              <Button type="info" size="large">{{
                $t("alarm.timeSet")
              }}</Button>

              <div slot="content" class="poptip-body">
                <Form
                  ref="timeForm"
                  label-position="right"
                  :label-width="130"
                  :model="timeForm"
                  :rules="ruleValidate"
                >
                  <FormItem :label="$t('alarm.delayTime')">
                    <InputNumber
                      v-model="timeForm.activeDelay"
                      :max="250"
                      :min="1"
                      size="large"
                      clearable
                      class="num-input"
                      :active-change="false"
                    ></InputNumber>
                  </FormItem>

                  <FormItem :label="$t('alarm.startDelay')">
                    <InputNumber
                      v-model="timeForm.triggerDelay"
                      :max="250"
                      :min="1"
                      size="large"
                      clearable
                      class="num-input"
                      :active-change="false"
                    ></InputNumber>
                  </FormItem>
                  <FormItem :label="$t('alarm.startUtil')">
                    <InputNumber
                      v-model="timeForm.duration"
                      :max="30"
                      :min="5"
                      size="large"
                      clearable
                      class="num-input"
                      :active-change="false"
                    ></InputNumber>
                  </FormItem>
                </Form>
                <div class="btn-box">
                  <Button type="primary" class="btn-margin" @click="closePop">{{
                    $t("common.ensure")
                  }}</Button>
                  <Button class="btn-margin" @click="resetForm">{{
                    $t("common.reset")
                  }}</Button>
                </div>
              </div>
            </Poptip>
          </i-col>
        </Row>
        <!-- 配置body -->
        <Table
          :columns="currentColunm"
          stripe
          border
          :data="currentList"
          class="table-margin"
          @click="test(111)"
        >
          <!-- 开关 -->
          <template slot="open" slot-scope="{ row, index }">
            <i-switch
              v-model="row.open"
              size="large"
              :true-value="1"
              :false-value="0"
              :before-change="beforeChange.bind(this, row)"
              @on-change="setOpen(row.open, index, row)"
            >
              <span slot="open">{{ $t("alarm.open") }}</span>
              <span slot="close">{{ $t("alarm.close") }}</span>
            </i-switch>
          </template>
          <!-- 探测器类型	 -->
          <template slot="sensor" slot-scope="{ row, index }">
            <Select
              v-model="row.sensor"
              size="large"
              clearable
              @on-change="setMachine(row.sensor, index)"
            >
              <Option
                v-for="(item, index) in machineList"
                :key="index"
                :value="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </template>
          <!-- 触发类型 -->
          <template slot="trigger" slot-scope="{ row, index }">
            <Select
              :ref="`trigger` + [index]"
              v-model="row.trigger"
              :element-id="`trigger` + [index]"
              size="large"
              clearable
              @on-change="setSendType(row.trigger, index, row)"
            >
              <Option
                v-for="(item, index) in sendList"
                :key="index"
                :value="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </template>
          <!-- 离家下的模式 -->
          <template slot="mode" slot-scope="{ row, index }">
            <i-switch
              v-model="row.mode"
              size="large"
              :true-value="1"
              :false-value="0"
              @on-change="setMode(row.mode, index)"
            >
              <span slot="open">{{ $t("alarm.mode1") }}</span>
              <span slot="close">{{ $t("alarm.mode2") }}</span>
            </i-switch>
          </template>
          <!-- 关联防区 -->
          <template slot="associated" slot-scope="{ row, index }">
            <InputNumber
              v-model="row.associated"
              :max="addForm.exZone ? 24 : 8"
              :min="1"
              size="large"
              clearable
              :active-change="false"
              @on-change="setAssociated(row.associated, index)"
            ></InputNumber>
          </template>
        </Table>
        <Row
          class="table-margin"
          :class="{ 'page-opact': addForm.exZone !== true }"
        >
          <i-col :span="24" class="text-center">
            <Page
              :current="pageIndex"
              :total="itemTotal"
              show-total
              :page-size="pageSize"
              @on-change="getPageList"
            />
          </i-col>
        </Row>
        <!-- 生成配置文件 -->
        <div class="submit-btn">
          <Button type="success" size="large" @click="submitList">{{
            $t("openConfig.produce")
          }}</Button>
        </div>
      </div>
    </div>

    <div class="content_win"></div>
  </div>
</template>

<script>
import childNav from "@/components/homeNav/childNav.vue";
export default {
  name: "openList",
  components: {
    childNav,
  },
  data() {
    return {
      addForm: {
        name: "0",
        zoneMode: "0",
        exZone: false,
      },
      currentList: [],
      adDataList: [],
      ioDataList: [],
      currentColunm: [],
      columns11: this.global.alarmColumns11,
      columns12: this.global.alarmColumns12,
      alarmList: this.global.alarmList,
      nameList: this.global.nameList,
      machineList: this.global.machineList,
      sendList: this.global.sendList,
      itemTotal: 24,
      adDataPage2: [],
      adDataPage3: [],
      ioDataPage2: [],
      ioDataPage3: [],
      pageIndex: 1,
      pageSize: 10,
      visible: false,
      timeForm: {
        activeDelay: 1,
        triggerDelay: 1,
        duration: 5,
      },
      ruleValidate: {},
      targetIndex: -1,
      targetType: -1,
      isAlarm1: false, // 延时报警的存在标识
      isAlarm2: false, // 传递延迟的存在标识
      alarmIndex2: -1, // 传递延迟的存在标识
    };
  },
  watch: {
    "addForm.name": {
      handler() {
        console.log(this.adDataList);
        console.log(this.ioDataList);
        this.pageIndex = 1;
        if (Number(this.addForm.name) === 0) {
          this.currentColunm = this.columns11;
          this.currentList = this.adDataList;
        } else if (Number(this.addForm.name) === 1) {
          this.currentColunm = this.columns12;
          this.currentList = this.ioDataList;
        }
      },
    },
    "addForm.exZone": {
      handler() {
        this.pageIndex = 1;
        if (!this.addForm.exZone) {
          if (Number(this.addForm.name) === 0) {
            this.currentList = this.adDataList;
          } else if (Number(this.addForm.name) === 1) {
            this.currentList = this.ioDataList;
          }
        }
      },
    },
    // 新增输入限制逻辑
    currentList: {
      handler(newValue, oldValue) {
        // 交叉报警逻辑，强制显示
        if (this.targetType === 1) {
          this.currentList[0].trigger = "4";
          this.currentList[this.targetIndex].trigger = "4";
        }
        if (this.targetType === 2) {
          this.currentList[6].trigger = "4";
          this.currentList[this.targetIndex].trigger = "4";
        }
      },
      // 开启深度监听
      deep: true,
    },
  },
  mounted() {
    // 新增输入限制逻辑
    this.currentColunm = this.columns11;
    let obj = {
      open: 1, // 24小时即报，需要是设置开关为开
      sensor: "0",
      trigger: "0", // 24小时即报，需要是设置开关为开
      mode: 0,
      associated: null,
    };
    for (let i = 0; i < 8; i++) {
      let num = i + 1;
      obj.index = num;
      let parseObj = JSON.parse(JSON.stringify(obj));
      this.adDataList.push(parseObj);
    }
    this.ioDataList = JSON.parse(JSON.stringify(this.adDataList));
    for (let i = 0; i < 8; i++) {
      let num = i + 9;
      obj.index = num;
      let parseObj = JSON.parse(JSON.stringify(obj));
      this.adDataPage2.push(parseObj);
    }
    this.ioDataPage2 = JSON.parse(JSON.stringify(this.adDataPage2));
    for (let i = 0; i < 8; i++) {
      let num = i + 17;
      obj.index = num;
      let parseObj = JSON.parse(JSON.stringify(obj));
      this.adDataPage3.push(parseObj);
    }
    this.ioDataPage3 = JSON.parse(JSON.stringify(this.adDataPage3));

    this.currentList = this.adDataList;

    setTimeout(() => {
      this.$Message.success(this.$t("updateConfig.tip0"));
    }, 1000);
  },
  methods: {
    // 增加输入限制逻辑-触发类型
    setTypeLimit(value, index, row) {
      // 24小时即0：选择24小时即报，开关要必开
      // 立即报警3：选择立即报警，开关要必开
      // 传递延迟2：web端修改：当延时报警开了，传递延时才可选择开启，范围：整个配置文件
      // 延时报警1：web端修改：当延时报警开了，传递延时才可选择开启，范围：整个配置文件
      // 交叉报警4：web端修改：当编号1或2设置为交叉防区时，编号2或1也变为交叉防区；同理编号7和8
      // （注意： 2、24小时即报：瓦斯、烟雾、门铃、收报按钮（选中之后，开关按钮显示开启状态)

      // 交叉报警逻辑
      let flag = this.handleSet();
      if (flag === 1) {
        // 编号1、2; 7、8（扩展不需要处理）
        // 交叉报警逻辑,选中交叉报警
        if (Number(value) === 4) {
          switch (index) {
            case 0:
              this.setSendType("4", 1);
              break;
            case 1:
              this.setSendType("4", 0);
              break;
            case 6:
              this.setSendType("4", 7);
              break;
            case 7:
              this.setSendType("4", 6);
              break;
          }
        } else {
          if (index === 0 || index === 1) {
            if (
              Number(this.currentList[0].trigger) === 4 ||
              Number(this.currentList[1].trigger) === 4
            ) {
              // 清空操作
              if (!value) {
                this.targetType = -1; // 清除currentList的强制操作
                this.currentList[0].trigger = "";
                this.currentList[1].trigger = "";
              } else {
                // 选中交叉报警后，保持交叉报警
                this.$Message.error(this.$t("updateConfig.tip4"));
                this.targetIndex = index;
                this.targetType = 1;
              }
              // 执行后，返回
              return;
            }
          }
          if (index === 6 || index === 7) {
            if (
              Number(this.currentList[6].trigger) === 4 ||
              Number(this.currentList[7].trigger) === 4
            ) {
              // 清空操作
              if (!value) {
                this.targetType = -1; // 清除currentList的强制操作
                this.currentList[6].trigger = "";
                this.currentList[7].trigger = "";
              } else {
                // 选中交叉报警后，保持交叉报警
                this.$Message.error(this.$t("updateConfig.tip4"));
                this.targetIndex = index;
                this.targetType = 2;
              }
              // 执行后，返回
              return;
            }
          }
        }
      }
      debugger;

      // 传递延迟2与延时报警1的逻辑
      if (Number(row.trigger) === 2) {
        // 选中传递延迟2
        console.log(4444444444444);
        this.currentList[index] = row;
        // 传递延迟与延时报警
        let isAlarm1 = this.isHadOpenAlarm(1)[0]; // 延时报警的存在标识
        let alarmIndexArray = this.isHadOpenAlarm(2)[2]; // 延时报警的存在标识

        // 判断传递延迟是否开启
        if (!isAlarm1 && Number(this.currentList[index].trigger) != 4) {
          this.$Message.error(this.$t("updateConfig.tip5"));
          // 若开启，则关闭
          if (row.open === 1) {
            alarmIndexArray.forEach((item) => {
              this.setOpen(0, item); // 所有的传递延时都要关闭
            });
          }
          // 执行后，返回
          return;
        }
      } else {
        this.currentList[index] = row;
        // 判断是否存在传递延迟
        let isAlarm1 = this.isHadOpenAlarm(1)[0]; // 延时报警的存在标识
        let isAlarm2 = this.isHadOpenAlarm(2)[0]; // 传递延迟的存在标识
        let alarmIndexArray = this.isHadOpenAlarm(2)[2]; // 传递延迟的存在标识
        if (!isAlarm1 && isAlarm2) {
          // 延时报警不存在，但传递延迟存在 （开关都开启），设置传递延迟关闭
          // 若开启，则关闭
          alarmIndexArray.forEach((item) => {
            this.setOpen(0, item); // 所有的传递延时都要关闭
          });
          // 执行后，返回
          return;
        }
      }

      // 24小时即报与立即报警逻辑
      if (Number(row.trigger) === 0 || Number(row.trigger) === 3) {
        // 24小时即报与立即报警选中时，设置开关为开
        if (Number(this.currentList[index].trigger) != 4) {
          this.setOpen(1, index);
          if (Number(row.trigger) === 0) {
            this.$Message.success(this.$t("updateConfig.tip0"));
          } else if (Number(row.trigger) === 3) {
            this.$Message.success(this.$t("updateConfig.tip6"));
          }
        }
      }
    },
    // 开关的切换之前动作反馈,做限制
    beforeChange(row) {
      return new Promise((resolve, reject) => {
        // 当开启24小时即报或立即报警
        if (Number(row.trigger) === 0 || Number(row.trigger) === 3) {
          // 当开关开启时，禁止关闭开关
          if (Number(row.open) === 1) {
            if (Number(row.trigger) === 0) {
              this.$Message.success(this.$t("updateConfig.tip1"));
            } else if (Number(row.trigger) === 3) {
              this.$Message.success(this.$t("updateConfig.tip2"));
            }
            // 取消操作
            reject();
          } else {
            resolve();
          }
        } else if (Number(row.trigger) === 2) {
          let isAlarm = this.isHadOpenAlarm(1)[0];
          // 判断延迟传递是否开启
          if (!isAlarm) {
            this.$Message.error(this.$t("updateConfig.tip5"));
            // 取消操作
            reject();
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    // 开关增加逻辑
    setOpenLimit(value, index, row) {
      // 操作延时报警时，设置开关为关
      if (Number(row.trigger) === 1 && Number(value) === 0) {
        this.currentList[index] = row;

        let isAlarm1 = this.isHadOpenAlarm(1)[0];
        let isAlarm2 = this.isHadOpenAlarm(2)[0];
        let alarmIndexArray = this.isHadOpenAlarm(2)[2];

        // 判断全局的传递延迟是否开启，开启则关闭
        if (isAlarm2 && !isAlarm1) {
          this.$Message.error(this.$t("updateConfig.tip3"));
          alarmIndexArray.forEach((item) => {
            this.setOpen(0, item); // 所有的传递延时都要关闭
          });
        }
      }
    },
    // 判断入参(triggerValue)的报警类型是否开启（整个配置）
    // 24小时即 0
    // 延时报警 1
    // 传递延迟 2
    // 立即报警 3
    // 交叉报警 4
    isHadOpenAlarm(triggerValue) {
      let isAlarm = false;
      let alarmIndex = -1; // 当前目标值的下标
      let alarmIndexArray = []; // 当前目标值的下标数组

      let array = [];
      if (Number(this.addForm.name) === 0) {
        // 扩展区
        if (this.addForm.exZone) {
          // ...this.currentList,
          array = [
            ...this.adDataList,
            ...this.adDataPage2,
            ...this.adDataPage3,
          ];
        } else {
          array = [...this.adDataList];
        }
        array.forEach((item, index) => {
          if (
            Number(item.trigger) === triggerValue &&
            Number(item.open) === 1
          ) {
            isAlarm = true;
            alarmIndex = index;
            alarmIndexArray.push(index);
          }
        });
      } else if (Number(this.addForm.name) === 1) {
        // 扩展区
        if (this.addForm.exZone) {
          array = [
            ...this.ioDataList,
            ...this.ioDataPage2,
            ...this.ioDataPage3,
          ];
        } else {
          array = [...this.ioDataList];
        }
        array.forEach((item, index) => {
          if (
            Number(item.trigger) === triggerValue &&
            Number(item.open) === 1
          ) {
            isAlarm = true;
            alarmIndex = index;
            alarmIndexArray.push(index);
          }
        });
      }
      return [isAlarm, alarmIndex, alarmIndexArray];
    },
    handleSet() {
      let res = null;
      if (this.addForm.exZone && this.pageIndex === 1) {
        res = 1;
      } else if (this.addForm.exZone && this.pageIndex === 2) {
        res = 2;
      } else if (this.addForm.exZone && this.pageIndex === 3) {
        res = 3;
      } else if (!this.addForm.exZone) {
        res = 1;
      }
      return res;
    },
    setMachine(value, index) {
      let flag = this.handleSet();
      console.log(flag);
      if (Number(this.addForm.name) === 0) {
        if (flag === 1) {
          this.adDataList[index].sensor = value;
        } else if (flag === 2) {
          this.adDataPage2[index].sensor = value;
        } else if (flag === 3) {
          this.adDataPage3[index].sensor = value;
        }
      } else if (Number(this.addForm.name) === 1) {
        if (flag === 1) {
          this.ioDataList[index].sensor = value;
        } else if (flag === 2) {
          this.ioDataPage2[index].sensor = value;
        } else if (flag === 3) {
          this.ioDataPage3[index].sensor = value;
        }
      }
    },
    setOpen(value, index, row, type) {
      let flag = this.handleSet();
      console.log(22222222222);

      if (row) {
        this.setOpenLimit(value, index, row, type);
      }

      if (Number(this.addForm.name) === 0) {
        if (flag === 1) {
          this.adDataList[index].open = value;
        } else if (flag === 2) {
          this.adDataPage2[index].open = value;
        } else if (flag === 3) {
          this.adDataPage3[index].open = value;
        }
      } else if (Number(this.addForm.name) === 1) {
        if (flag === 1) {
          this.ioDataList[index].open = value;
        } else if (flag === 2) {
          this.ioDataPage2[index].open = value;
        } else if (flag === 3) {
          this.ioDataPage3[index].open = value;
        }
      }
    },
    setSendType(value, index, row) {
      let targetvalue = value;

      if (row) {
        this.setTypeLimit(targetvalue, index, row);
      }

      let flag = this.handleSet();
      if (Number(this.addForm.name) === 0) {
        if (flag === 1) {
          this.adDataList[index].trigger = targetvalue;
        } else if (flag === 2) {
          this.adDataPage2[index].trigger = targetvalue;
        } else if (flag === 3) {
          this.adDataPage3[index].trigger = targetvalue;
        }
      } else if (Number(this.addForm.name) === 1) {
        if (flag === 1) {
          this.ioDataList[index].trigger = targetvalue;
        } else if (flag === 2) {
          this.ioDataPage2[index].trigger = targetvalue;
        } else if (flag === 3) {
          this.ioDataPage3[index].trigger = targetvalue;
        }
      }
    },

    setMode(value, index) {
      let flag = this.handleSet();
      if (Number(this.addForm.name) === 0) {
        if (flag === 1) {
          this.adDataList[index].mode = value;
        } else if (flag === 2) {
          this.adDataPage2[index].mode = value;
        } else if (flag === 3) {
          this.adDataPage3[index].mode = value;
        }
      } else if (Number(this.addForm.name) === 1) {
        if (flag === 1) {
          this.ioDataList[index].mode = value;
        } else if (flag === 2) {
          this.ioDataPage2[index].mode = value;
        } else if (flag === 3) {
          this.ioDataPage3[index].mode = value;
        }
      }
    },

    setAssociated(value, index) {
      let flag = this.handleSet();
      if (Number(this.addForm.name) === 0) {
        if (flag === 1) {
          this.adDataList[index].associated = value;
        } else if (flag === 2) {
          this.adDataPage2[index].associated = value;
        } else if (flag === 3) {
          this.adDataPage3[index].associated = value;
        }
      } else if (Number(this.addForm.name) === 1) {
        if (flag === 1) {
          this.ioDataList[index].associated = value;
        } else if (flag === 2) {
          this.ioDataPage2[index].associated = value;
        } else if (flag === 3) {
          this.ioDataPage3[index].associated = value;
        }
      }
    },

    // 分页
    getPageList(index) {
      this.pageIndex = index;
      console.log(index);
      this.currentList = [];
      if (Number(this.addForm.name) === 0) {
        if (Number(index) === 1) {
          this.currentList = [...this.adDataList];
        } else if (Number(index) === 2) {
          this.currentList = [...this.adDataPage2];
        } else if (Number(index) === 3) {
          this.currentList = [...this.adDataPage3];
        }
      } else if (Number(this.addForm.name) === 1) {
        if (Number(index) === 1) {
          this.currentList = [...this.ioDataList];
        } else if (Number(index) === 2) {
          this.currentList = [...this.ioDataPage2];
        } else if (Number(index) === 3) {
          this.currentList = [...this.ioDataPage3];
        }
      }

      console.log(this.currentList);
    },
    // 修改每页显示条数
    getPageSize(size) {
      this.pageIndex = 1;
      this.pageSize = size;
    },

    submitList() {
      console.log(this.adDataList);
      console.log(this.adDataPage2);
      console.log(this.adDataPage3);
      console.log(this.ioDataList);
      console.log(this.ioDataPage2);
      console.log(this.ioDataPage3);
      let resJson = {};
      let preResList = [];
      let leaveResList = [];
      if (this.addForm.exZone) {
        //   扩展 24
        // ad
        preResList = this.adDataList.concat(this.adDataPage2, this.adDataPage3);
        // io
        leaveResList = this.ioDataList.concat(
          this.ioDataPage2,
          this.ioDataPage3
        );
      } else {
        //   8
        // ad
        preResList = this.adDataList;
        // io
        leaveResList = this.ioDataList;
      }

      resJson.zoneMode = this.alarmList[Number(this.addForm.zoneMode)].name;
      resJson.activeDelay = this.timeForm.activeDelay;
      resJson.triggerDelay = this.timeForm.triggerDelay;
      resJson.duration = this.timeForm.duration;
      resJson.exZone = this.addForm.exZone;
      resJson.zoneConfig = [
        {
          name: "leaving",
          attribute: [],
        },
        {
          name: "Presence",
          attribute: [],
        },
      ];
      leaveResList.map((item, ind) => {
        let obj = {
          no: ind + 1,
          enable: item.open,
          sensor: this.machineList[Number(item.sensor)].name,
          trigger: this.sendList[Number(item.trigger)].name,
          mode: Number(item.mode) === 1 ? "open" : "close",
        };
        if (item.associated) {
          obj.Linked = Number(item.associated);
        }
        resJson.zoneConfig[0].attribute.push(obj);
      });

      preResList.map((item, ind) => {
        let obj = {
          no: ind + 1,
          enable: item.open,
          sensor: this.machineList[Number(item.sensor)].name,
          trigger: this.sendList[Number(item.trigger)].name,
        };
        if (item.associated) {
          obj.Linked = Number(item.associated);
        }
        resJson.zoneConfig[1].attribute.push(obj);
      });

      let res = JSON.stringify(resJson);
      console.log(preResList);
      console.log(leaveResList);
      console.log(resJson);
      console.log(res);

      let export_blob = new Blob([res]);
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(export_blob);
      downloadElement.href = href;
      downloadElement.download = "alarm.bin"; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    },
    // 重置表单
    resetForm() {
      this.timeForm = {
        activeDelay: 1,
        triggerDelay: 1,
        duration: 5,
      };
    },
    // 关闭弹窗
    closePop() {
      this.visible = false;
    },
  },
};
</script>
